const SELECTOR = '.js-schedule-five-month-select';

/**
 * Returns currentUrl with the scheduleFiveId query parameter set to
 * scheduleFiveId, replacing any value already there. The controller reads that
 * parameter to decide which month of the Schedule 5 to render, so switching
 * month is a normal page load and every grid picks up the new id from the
 * hidden inputs without being rebuilt.
 */
export const buildMonthUrl = (currentUrl, scheduleFiveId) => {
    const url = new URL(currentUrl);
    url.searchParams.set('scheduleFiveId', scheduleFiveId);
    return url.toString();
};

/**
 * Builds the select's change handler. location and navigate are injected so the
 * behaviour can be covered without touching window. Kendo invokes the handler
 * with the widget as `this` and an event argument, which is not needed here.
 */
export const createMonthChangeHandler = (location, navigate) => function() {
    const scheduleFiveId = this.value();
    if (!scheduleFiveId) return;
    navigate(buildMonthUrl(location.href, scheduleFiveId));
};

export default function() {
    const $select = $(SELECTOR);
    if (!$select.length) return null; //Element doesn't exist

    const existing = $select.data('kendoDropDownList');
    if (existing) return existing; //Already initialized

    // The select already carries one option per month with the current month
    // marked selected, so the widget needs no dataSource of its own.
    const k_monthSelect = $select.kendoDropDownList().data('kendoDropDownList');

    k_monthSelect.bind('change', createMonthChangeHandler(
        window.location,
        url => {
            window.location = url;
        },
    ));

    return k_monthSelect;
}
